import { makeStyles } from 'tss-react/mui';

const NotificationBellViewStyles = makeStyles()(() => ({
	container: {
		display: 'flex',
		alignItems: 'center',
	},
}));

export default NotificationBellViewStyles;
